var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJquery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 121.74",
    style: {
      enableBackground: "new 0 0 122.88 121.74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#21609B;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.03,90.36l-0.55,1.43c-9.37,18.25-25.98,29.45-49.67,29.94c-11.07,0.23-21.63-2.61-28.52-5.7 C26.41,109.35,13.9,96.95,7.07,83.71c-9.8-18.98-11.57-45.39,8.81-65.11c0.31,0-2.47,4.28-2.16,4.28l-0.56,1.83 c-14.69,45.98,30.56,85.38,74.54,80.88C98.28,104.49,111.76,98.7,120.03,90.36L120.03,90.36L120.03,90.36z M120.03,90.36 L120.03,90.36L120.03,90.36L120.03,90.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.41,71.35c11.07,0.08,22.62-5.1,29.47-12.36c-5.99,15.2-23.33,24.97-46.58,21.86 c-19.47-2.61-38.01-22.2-39.92-41.83c-1.4-14.29,3.58-22.81,11.79-33.16c-2.85,5.41-3.92,9.58-4.18,12.24 C40.86,49.02,68.67,71.19,93.41,71.35L93.41,71.35L93.41,71.35z M93.41,71.35L93.41,71.35L93.41,71.35L93.41,71.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.77,32.97c-1.72,3.95-11.62,11.4-16,12.33c-17.32,3.69-28.41-4.52-34.22-13.87 c-0.86-1.4-2.46-5.21-2.75-6.18C66.55,17.59,67.58,6,74.3,0c-2.02,5.7-2.32,12.33-1.25,16.64c0.65,2.6,2.61,7.15,4.58,10.01 c3.58,5.21,5.85,6.47,10.46,9.24c2.07,1.24,4.3,2.24,5.26,2.52C97.71,39.69,106.92,43.07,121.77,32.97L121.77,32.97L121.77,32.97z M121.77,32.97L121.77,32.97L121.77,32.97L121.77,32.97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJquery);
export default __webpack_public_path__ + "static/media/jquery.09989e759a48457318671473750bbebf.svg";
export { ForwardRef as ReactComponent };